<template>
  <div>
    <van-popup round closeable v-model="showTag">
      <div class="container flex column flex-center flex-center-2 pt50 pb50">
        <h3 class="fs18 fw500 color_333 mb20">联系客服</h3>
        <div class="flex flex-center mb20">
          <a :href="href"></a>
          <span class="fs16">{{ mobile }}</span>
        </div>
        <p>平台医助工作时间</p>
        <p>{{ workTime }}</p>
        <p>上午 {{ workAm }}</p>
        <p>下午 {{ workPm }}</p>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "kefu",
  data() {
    return {
      showTag: false,
      workPm: '',
      workAm: '',
      workTime: '',
      mobile: ''
    }
  },
  computed: {
    href() {
      let mobile = this.mobile;
      if (!mobile) mobile = '057187767077';
      return `tel:${mobile.replace(/-/g, '')}`
    }
  },
  methods: {
    open() {
      if (!this.mobile) this.mobile = '057187767077';
      this.showTag = true;
    },
    close() {
      this.showTag = false;
    }
  },
}
</script>

<style scoped lang="scss">
@import "~@/common/public.scss";

.container {
  width: px2rem(300px);

  p {
    line-height: 2;
    font-size: 14px;
    color: #333333;
  }
}
</style>



// WEBPACK FOOTER //
// src/plugins/dialog/kefu.vue